import script from "./AdviserRoomAssign.vue?vue&type=script&setup=true&lang=js"
export * from "./AdviserRoomAssign.vue?vue&type=script&setup=true&lang=js"

import "./AdviserRoomAssign.vue?vue&type=style&index=0&id=5209ac56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5209ac56"]])

export default __exports__